/**
 * Data object representing the external questionnaires list item
 * @note This is usually used in the data table as a row. Params don't have default values since this data object is 
 * used to represent data that actually exists.
 */
export class ExternalQuestionnairesListItemDataObject {
	/**
	 * @param {string} id - DB ID of the external questionnaire.
	 * @param {string} accountId - DB ID of the account external questionnaire is assigned to.
	 * @param {string} name - Name of the external questionnaire.
	 */
	constructor(id, accountId, name) {
		this.id = id;
		this.accountId = accountId;
		this.name = name;
	}
}

/**
 * Data object representing the external questionnaires list items list of external questionnaires
 * @note This is usually used in the data table as a row. Params don't have default values since this data object is
 * used to represent data that actually exists.
 */
export class ExternalQuestionnairesItemQuestionnairesListDataObject {
	/**
	 * @param {string} id - DB ID of the user submitted questionnaire.
	 * @param {string} firstName - First name that the user submitted in the questionnaire.
	 * @param {string} lastName - Last name that the user submitted in the questionnaire.
	 * @param {Date} dateOfBirth - Date of birth that the user submitted in the questionnaire.
	 * @param {Date} dateOfSubmission - Date of submission that the user submitted in the questionnaire.
	 * @param {string} [studyRefNo] - Reference number of the study the questionnaire is assigned to (for admins).
	 * @param {boolean} [deleted] - Whether the questionnaire has been deleted (for admins).
	 */
	constructor(id, firstName, lastName, dateOfBirth, dateOfSubmission, studyRefNo, deleted) {
		this.id = id;
		this.firstName = firstName;
		this.lastName = lastName;
		this.dateOfBirth = dateOfBirth;
		this.dateOfSubmission = dateOfSubmission;
		
		// Admin-only properties
		this.studyRefNo = studyRefNo;
		this.deleted = deleted;
	}
}